import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import MicroModal from 'micromodal';

gsap.registerPlugin(Draggable);

function moduleHotspots() {

    // console.log('moduleHotspots');


    Draggable.create(".hotspots__draggable", {
        type: "x",
        bounds: ".hotspots__draggable__parent",
        edgeResistance: 1
    });

    MicroModal.init({
        closeTrigger: 'data-custom-close',
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
    });
}

export default moduleHotspots;